import clsx from "clsx";
import { Text } from "./base";

type Props = {
  status: string;
  phase?: string | null;
};

const STATUS_LABELS: Record<string, string> = {
  merging: "Merging",
  creating: "Creating",
  running: "Running",
  terminating: "Terminating",
  terminated: "Terminated",
  failed: "Failed",
};

// sub-state shown while merging/creating (the vLLM endpoint coming up)
const PHASE_LABELS: Record<string, string> = {
  MERGING: "Merging",
  PENDING: "Pending",
  STARTING: "Starting",
  PULLING: "Pulling",
  READY: "Ready",
};

export const FineTuningDeploymentStatusPill = ({ status, phase }: Props) => {
  const label = STATUS_LABELS[status] ?? status;
  const detail = (status === "merging" || status === "creating") && phase ? ` · ${PHASE_LABELS[phase] ?? phase}` : "";
  return (
    <Text
      className={clsx(
        "w-auto px-2 py-0.5 rounded-full text-xs whitespace-nowrap",
        status === "running" && "bg-success/10 dark:bg-success/20 text-success-dark dark:text-success-light",
        (status === "merging" || status === "creating" || status === "terminating") &&
          "bg-yellow-100 dark:bg-yellow-900/40 text-yellow-800 dark:text-yellow-300",
        status === "terminated" && "bg-gray-100 dark:bg-gray-700/40 text-gray-700 dark:text-gray-300",
        status === "failed" && "bg-error/10 dark:bg-error/20 text-error-dark dark:text-error-light",
      )}
    >
      {label}
      {detail}
    </Text>
  );
};
